import { BffBrandType } from '@/types/generated';

import { getGraphHeaders } from '@utils/getGraphHeaders';
import { logWarning } from '@utils/miscUtils';

export interface IGetBffFacilitiesBySearchParams {
	brand: BffBrandType;
	address: string;
	url: string;
	fetchAllIfNoResults: boolean | undefined;
	appName: string;
	appVersion: string;
}

export const getBffFacilitiesBySearch = async ({
	brand,
	address,
	url,
	fetchAllIfNoResults,
	appName,
	appVersion,
}: IGetBffFacilitiesBySearchParams) => {
	try {
		if (!brand) {
			return null;
		}
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '@src/lib/graphql/getGraphQLClient'
		);
		return await getGraphQLClient(url).bffFacilitiesBySearch(
			{
				brand,
				address,
				fetchAllIfNoResults,
			},
			getGraphHeaders(appName, appVersion)
		);
	} catch (err) {
		logWarning(`Could not find any facilities data for: ${brand} for query: ${address}: ${(err as Error).message}`);
		return null;
	}
};
